import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const getOpenBoardFilterBarStyles = (theme: Theme) =>
  StyleSheet.create({
    bar: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
      paddingHorizontal: 14,
      paddingTop: 4,
      paddingBottom: 8,
    },
    filterButton: {
      width: 36,
      height: 36,
      borderRadius: 10,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.background.card,
      borderWidth: 1,
      borderColor: theme.gray[200],
      flexShrink: 0,
    },
    filterButtonActive: {
      backgroundColor: theme.background.cardElevated,
      borderColor: theme.primary,
    },
    filterButtonPressed: {
      opacity: 0.8,
    },
    /** Count of active constraints; sits proud of the button's top-right corner. */
    filterBadge: {
      position: 'absolute',
      top: -5,
      right: -5,
      minWidth: 16,
      height: 16,
      borderRadius: 999,
      paddingHorizontal: 4,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.secondary,
    },
    filterBadgeText: {
      fontSize: 9,
      fontWeight: '800',
      color: theme.textOnStatusBadge,
    },
    chipScroller: {
      flex: 1,
    },
    chipRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
      paddingRight: 4,
    },
    chip: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 5,
      borderRadius: 999,
      paddingHorizontal: 11,
      paddingVertical: 7,
      backgroundColor: theme.background.card,
      borderWidth: 1,
      borderColor: theme.gray[200],
    },
    chipActive: {
      backgroundColor: theme.background.cardElevated,
      borderColor: theme.primary,
    },
    /** The big-slate chip reads gold when on, matching the crown on those cards. */
    chipAccent: {
      backgroundColor: theme.background.cardElevated,
      borderColor: theme.accent,
    },
    chipCrown: {
      width: 12,
      height: 12,
    },
    chipPressed: {
      opacity: 0.8,
    },
    chipLabel: {
      fontSize: 12.5,
      fontWeight: '700',
      color: theme.gray[500],
    },
    chipLabelActive: {
      color: theme.primaryLight,
    },
    chipLabelAccent: {
      color: theme.accent,
    },

    // ── result line + sort ──────────────────────────────────────────────────
    resultRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingHorizontal: 18,
      paddingBottom: 8,
      gap: 12,
    },
    resultText: {
      flexShrink: 1,
      fontSize: 12,
      fontWeight: '600',
      color: theme.gray[500],
    },
    sortControl: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 4,
      flexShrink: 0,
    },
    sortPressed: {
      opacity: 0.7,
    },
    sortLabel: {
      fontSize: 12,
      fontWeight: '700',
      color: theme.primary,
    },
  });
